import getService from './get';
import updateService from './update';

export default [getService, updateService];
